import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Button,
} from "reactstrap";
import JsonEditor from "./JsonEditor";

/**
 * Placement Edit Form Component
 */
const PlacementEditForm = ({
    shop,
    value,
    field,
    jsonError,
    onInputChange,
    onJsonChange,
    onSubmit,
}) => {
    const getFieldLabel = () => {
        switch (field) {
            case "total_fees":
                return "Total Fees";
            case "placement":
                return "Placement";
            case "public_access_token":
                return "Access Token";
            case "collection_base_url":
                return "Collection Base URL";
            case "cart_location":
                return "Cart Location";
            default:
                return field;
        }
    };

    return (
        <Form onSubmit={onSubmit}>
            <FormGroup>
                <Label htmlFor="placement-edit-shop">Store Domain</Label>
                <Input
                    value={shop}
                    type="text"
                    name="shop"
                    id="placement-edit-shop"
                    onChange={onInputChange}
                    readOnly
                    className="bg-light"
                />
            </FormGroup>
            <FormGroup>
                <Label htmlFor={field === "cart_location" ? undefined : "placement-edit-value"}>
                    {getFieldLabel()}
                </Label>
                {field !== "cart_location" && (
                    <Input
                        value={value}
                        type="text"
                        name="value"
                        id="placement-edit-value"
                        onChange={onInputChange}
                        required
                    />
                )}
                {field === "cart_location" && (
                    <>
                        <JsonEditor initialValue={value} onChange={onJsonChange} />
                        {jsonError && <p className="text-danger small mt-2 mb-0">{jsonError}</p>}
                    </>
                )}
            </FormGroup>
            <FormGroup className="mb-0">
                <Button type="submit" color="primary">
                    Update
                </Button>
            </FormGroup>
        </Form>
    );
};

PlacementEditForm.propTypes = {
    shop: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired,
    field: PropTypes.string.isRequired,
    jsonError: PropTypes.string,
    onInputChange: PropTypes.func.isRequired,
    onJsonChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default PlacementEditForm;

